import { DamageType } from "../../damageType";
import { BigContainer } from "../bigContainer";

export class InvulnerableBigContainer extends BigContainer {
	static key = "InvulnerableBigContainer";
	constructor() {
		super();
		this.maxHp = 30;
		this.hp = 30;
		this.damageMultipliers.set(DamageType.BUBBLE, 0);
		this.damageMultipliers.set(DamageType.TOXIC_GAS, 0);
		this.damageMultipliers.set(DamageType.ELECTRIC, 0);
		this.damageMultipliers.set(DamageType.BLAST, 0);
		this.damageMultipliers.set(DamageType.EXPLOSION, 0);
		this.damageMultipliers.set(DamageType.MELEE, 0);
	}

	static deserialize(data: any): InvulnerableBigContainer {
		const c = new InvulnerableBigContainer();
		c.restoreCoreFields(data);
		return c;
	}
}
